import React, { useReducer, useState } from 'react';

import "./CharacterWizard.scss";
import { Block } from "@randajan/jet-react/dom/block";

import { usePopSelf } from '@randajan/jet-react/dom/modal';
import { useWizard, Wizard } from '../../../elements/Wizard/Wizard';

const InSlide = (props)=>{
    const { form:Form } = props;
    const wiz = useWizard();
    return <Form {...props} onCancel={wiz.cancel} onSaved={wiz.next}/>
}

export const CharacterWizard = (props) => {
    const { profile, forms } = props;
    const pop = usePopSelf();

    return (
        <Wizard
            className="CharacterWizard" 
            onCancel={_=>pop.down()}
            onComplete={_=>pop.down(true)}
            direction={"toDown"}
        >
            {forms?.map(form=>{
                return <InSlide form={form} profile={profile}/>
            })}
        </Wizard>
    )
}